import { action, observable } from 'mobx'
// Request
import { TinTucRequest } from '../requests/TinTucRequest'

class TinTucStore {
  @observable newsList = []
  @observable newDetails = {}
  @observable tinTucTotalCount = 0

  @observable tintucQueryParams = {
    page: 0,
    size: 10,
  }

  setTintucQueryParams = payload => {
    this.tintucQueryParams = payload
  }

  /** Get work schedule */
  @action getAllNews = ({ replace = false } = {}) => {
    return new Promise((resolve, reject) => {
      TinTucRequest.getAllNews(
        this.tintucQueryParams.page,
        this.tintucQueryParams.size
      )
        .then(response => {
          const responseData = response.data.data
          this.newsList = replace
            ? responseData
            : [...this.newsList, ...responseData]
          this.tinTucTotalCount = response.data.total_count
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getById = id => {
    return new Promise((resolve, reject) => {
      TinTucRequest.getById(id)
        .then(response => {
          this.newDetails = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action create = tinTuc => {
    return new Promise((resolve, reject) => {
      TinTucRequest.create(tinTuc)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action update = tinTuc => {
    return new Promise((resolve, reject) => {
      TinTucRequest.update(tinTuc)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action delete = id => {
    return new Promise((resolve, reject) => {
      TinTucRequest.delete(id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action clear = () => {
    this.newsList.length = 0
    this.tinTucTotalCount = 0
    this.tintucQueryParams = {
      page: 0,
      size: 10,
    }
  }

  @action clearNewDetails = () => {
    this.newDetails = {}
  }

  @action createCurrentUserReadNews = payload => {
    return new Promise((resolve, reject) => {
      TinTucRequest.createCurrentUserReadNews(payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getReadNewsByUsername = username => {
    return new Promise((resolve, reject) => {
      TinTucRequest.getReadNewsByUsername(username)
        .then(response => {
          resolve(response)
          const readNewsIds = response.data.map(item => item.newsId)
          this.newsList = this.newsList.filter(
            item => !readNewsIds.includes(item.id)
          )
        })
        .catch(error => {
          reject(error)
        })
    })
  }

}

export default new TinTucStore()
